<template>
  <success title="已预约" :btn-list="btnData">
  </success>
</template>
<script>
import Success from '../components/Success'
export default {
  components: { Success },
  data() {
    return {
      btnData: []
    }
  },
  created() {
    let list = [{
      link: `/appointment/newAppointment`,
      name: '新增预约'
    }, {
      link: `/appointment/index`,
      name: '返回首页'
    }]
    this.btnData = list
  }
}

</script>
<style lang="less" scoped>
.inquiry-conditon-btn {
  margin-top: 1rem;
  text-align: center;
  font-size: 0.4rem;
  color: #598ffd;
}
</style>
